var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React from 'react';
import classnames from 'classnames';
import { propTypes } from './types';
import './NxVulnerabilityCounter.scss';
export default function NxVulnerabilityCounter(props) {
    var _a;
    var criticalCount = props.criticalCount, highCount = props.highCount, mediumCount = props.mediumCount, lowCount = props.lowCount, noneCount = props.noneCount, unspecifiedCount = props.unspecifiedCount, layout = props.layout, className = props.className, attrs = __rest(props, ["criticalCount", "highCount", "mediumCount", "lowCount", "noneCount", "unspecifiedCount", "layout", "className"]);
    var layoutClasses = classnames('nx-vulnerability-counter-container', className, (_a = {},
        _a["nx-vulnerability-counter-container--".concat(layout)] = layout,
        _a));
    if (typeof criticalCount !== 'number' &&
        typeof highCount !== 'number' &&
        typeof mediumCount !== 'number' &&
        typeof lowCount !== 'number' &&
        typeof noneCount !== 'number' &&
        typeof unspecifiedCount !== 'number') {
        console.warn('No counts have been provided and so nothing will be rendered.');
        return null;
    }
    return (React.createElement("dl", __assign({ className: layoutClasses }, attrs),
        typeof criticalCount === 'number' && (React.createElement("div", { className: "nx-vulnerability-counter nx-vulnerability-counter--critical" },
            React.createElement("dt", { className: "nx-vulnerability-counter__text" }, "Critical"),
            React.createElement("dd", { className: "nx-vulnerability-counter__count" }, criticalCount))),
        typeof highCount === 'number' && (React.createElement("div", { className: "nx-vulnerability-counter nx-vulnerability-counter--high" },
            React.createElement("dt", { className: "nx-vulnerability-counter__text" }, "High"),
            React.createElement("dd", { className: "nx-vulnerability-counter__count" }, highCount))),
        typeof mediumCount === 'number' && (React.createElement("div", { className: "nx-vulnerability-counter nx-vulnerability-counter--medium" },
            React.createElement("dt", { className: "nx-vulnerability-counter__text" }, "Medium"),
            React.createElement("dd", { className: "nx-vulnerability-counter__count" }, mediumCount))),
        typeof lowCount === 'number' && (React.createElement("div", { className: "nx-vulnerability-counter nx-vulnerability-counter--low" },
            React.createElement("dt", { className: "nx-vulnerability-counter__text" }, "Low"),
            React.createElement("dd", { className: "nx-vulnerability-counter__count" }, lowCount))),
        typeof noneCount === 'number' && (React.createElement("div", { className: "nx-vulnerability-counter nx-vulnerability-counter--none" },
            React.createElement("dt", { className: "nx-vulnerability-counter__text" }, "None"),
            React.createElement("dd", { className: "nx-vulnerability-counter__count" }, noneCount))),
        typeof unspecifiedCount === 'number' && (React.createElement("div", { className: "nx-vulnerability-counter nx-vulnerability-counter--unspecified" },
            React.createElement("dt", { className: "nx-vulnerability-counter__text" }, "Unspecified"),
            React.createElement("dd", { className: "nx-vulnerability-counter__count" }, unspecifiedCount)))));
}
NxVulnerabilityCounter.propTypes = propTypes;
//# sourceMappingURL=NxVulnerabilityCounter.js.map